import { render } from "./socialMedia.vue?vue&type=template&id=8a1ae18c"
import script from "./socialMedia.vue?vue&type=script&lang=js"
export * from "./socialMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__